import {inject} from '@angular/core';
import {Router, CanActivateFn} from '@angular/router';
import {ClerkService} from 'ngx-clerk';
import {map, take, filter, switchMap, timeout, catchError} from 'rxjs/operators';
import {of} from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const clerk = inject(ClerkService);
  const router = inject(Router);

  // Wait for Clerk to be loaded first, with timeout fallback
  return clerk.clerk$.pipe(
    filter(clerkInstance => clerkInstance !== null), // Wait for Clerk to load
    take(1),
    switchMap(() => clerk.user$),
    take(1),
    timeout(5000), // 5 second timeout
    map(user => {
      if (user) {
        return true; // User is authenticated, allow access
      } else {
        // User not authenticated, redirect to landing
        router.navigate(['/landing'], {replaceUrl: true});
        return false;
      }
    }),
    catchError(() => {
      // If Clerk fails to load or times out, allow access to landing
      router.navigate(['/landing'], {replaceUrl: true});
      return of(false);
    })
  );
};

export const guestGuard: CanActivateFn = (route, state) => {
  const clerk = inject(ClerkService);
  const router = inject(Router);

  // Wait for Clerk to be loaded first, with timeout fallback
  return clerk.clerk$.pipe(
    filter(clerkInstance => clerkInstance !== null), // Wait for Clerk to load
    take(1),
    switchMap(() => clerk.user$),
    take(1),
    timeout(5000), // 5 second timeout
    map(user => {
      if (!user) {
        return true; // User not authenticated, allow access to landing
      } else {
        // User is authenticated, redirect to main app
        router.navigate(['/'], {replaceUrl: true});
        return false;
      }
    }),
    catchError(() => {
      // If Clerk fails to load or times out, allow access to landing
      return of(true);
    })
  );
};
